import { createSlice } from '@reduxjs/toolkit';
import { Error } from '../../../Data/error.dto';
import { OrderReducer } from '../../Reducers/Dashboard/OrderReducer';

export interface OrderState {
    loading: boolean;
    allOrders: any[];
    totalCount: number;
    currentOrder?: any;
    error: Error;
    isError: boolean;
}

const initialState: OrderState = {
    loading: false,
    allOrders: [],
    totalCount: 0,
    currentOrder: null,
    error: {},
    isError: false,
};

const OrderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        OrderReducer(builder);
    },
});

export default OrderSlice.reducer;
